export class Declaration {
  constructor(sDeclarationId: number, sDeclarionFlag: boolean) {
    this.sDeclarationId = sDeclarationId;
    this.sDeclarionFlag = sDeclarionFlag;
  }
  sDeclarationId = 0;
  sDeclarionFlag = false;
  sExplanation = "";
  sPrimaryResidenceIndicator: boolean;
  sHomeownerPastThreeYearsType: boolean;
  sFamilyRelationOrBusinessAffiliation: boolean;
  sBorrowForRealEstateTransaction: boolean;
  sUndisclosedMortgageApplicationIndicator: boolean;
  sUndisclosedCreditApplicationIndicator: boolean;
  sPropertyProposedCleanEnergyLienIndicator: boolean;
  sUndisclosedBorrowedFundsIndicator: boolean;
  sOutstandingJudgmentsIndicator: boolean;
  sPresentlyDelinquentIndicator: boolean;
  sPartyToLawsuitIndicator: boolean;
  sPriorPropertyDeedInLieuConveyedIndicator: boolean;
  sPriorPropertyShortSaleCompletedIndicator: boolean;
  sPriorPropertyForeclosureCompletedIndicator: boolean;
  sBankruptcyIndicator: boolean;
  sUndisclosedComakerOfNoteIndicator : boolean;
}
